import { appConstants } from "../../constants/appconstants";
import { postApiCall, putApiCall, getApiCall } from "../../utils/ApiMethods";

const FetchNpsKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/nps/save-feedback`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_NPS_DETAIL_VIEW_ACTION', data: data }, data);
        dispatch(resData);
    }
}
const CancelNpsKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/nps/feedback-dismiss`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_NPS_CANCEL_ACTION' }, data);
        dispatch(resData);
    }
}
const CancelWalkmeAccessAction = (requestObj) => {
    return async function (dispatch) {
        const email = requestObj?.emailId
        const data = await putApiCall(`${appConstants.BASE_URL}/user/walkme?emailId=${email}`)
        var resData = Object.assign({ type: 'SUCCESS_CANCEL_WALKME_ACCESS_ACTION' }, data);
        dispatch(resData);
    }
}
export { FetchNpsKpiAction, CancelNpsKpiAction, CancelWalkmeAccessAction }